(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = Math.round(cents / 100);
    return '$' + amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function init(root) {
    if (root.dataset.bmTopReady === 'true') return;
    root.dataset.bmTopReady = 'true';

    var wrapper = root.parentElement;
    var variantsJson = wrapper.querySelector('[data-bm-product-json]');
    var initialOptionsJson = wrapper.querySelector('[data-bm-initial-options]');
    if (!variantsJson) return;

    var variants;
    var selection = [];
    try {
      variants = JSON.parse(variantsJson.textContent);
      selection = initialOptionsJson ? JSON.parse(initialOptionsJson.textContent) : [];
    } catch (e) {
      return;
    }

    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bm-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bm-slide]'));
    var priceCurrentEl = root.querySelector('[data-bm-price-current]');
    var priceCompareEl = root.querySelector('[data-bm-price-compare]');
    var discountPill = root.querySelector('[data-bm-discount-pill]');
    var savingEl = root.querySelector('[data-bm-saving]');
    var galleryBadge = root.querySelector('.bm-gallery__badge');

    /* ---------------- Precio ---------------- */

    function updatePrice(variant) {
      if (!variant) return;

      if (priceCurrentEl) priceCurrentEl.textContent = formatMoney(variant.price);

      var hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
      var pct = hasDiscount
        ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)
        : 0;

      if (priceCompareEl) {
        if (hasDiscount) {
          priceCompareEl.textContent = formatMoney(variant.compare_at_price);
          priceCompareEl.style.display = '';
        } else {
          priceCompareEl.style.display = 'none';
        }
      }

      if (discountPill) {
        discountPill.textContent = '-' + pct + '%';
        discountPill.style.display = hasDiscount ? '' : 'none';
      }
      if (galleryBadge) {
        galleryBadge.textContent = '-' + pct + '%';
        galleryBadge.style.display = hasDiscount ? '' : 'none';
      }
      if (savingEl) {
        if (hasDiscount) {
          savingEl.innerHTML = 'Ahorras <strong>' +
            formatMoney(variant.compare_at_price - variant.price) + '</strong> hoy';
          savingEl.style.display = '';
        } else {
          savingEl.style.display = 'none';
        }
      }
    }

    function findVariant(sel) {
      return variants.find(function (variant) {
        return ['option1', 'option2', 'option3'].every(function (key, index) {
          return sel[index] === undefined || variant[key] === sel[index];
        });
      });
    }

    // Deja la variante elegida visible para el botón de compra de la app (EasySell):
    // actualiza todo input name="id" de la página y el parámetro ?variant= de la URL,
    // que son las dos formas en que estas apps suelen leer la variante activa.
    function syncVariantForApps(variant) {
      if (!variant) return;

      // Todos los campos ocultos que marcamos nosotros, estén en el hero, en un
      // paso, en la barra fija o en el llamado final.
      document
        .querySelectorAll('input[name="id"][data-bm-variant-id]')
        .forEach(function (input) { input.value = variant.id; });

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        // navegadores sin URL API: el input oculto ya quedó actualizado
      }

      document.dispatchEvent(new CustomEvent('bm:variant-selected', { detail: { variant: variant } }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    document.addEventListener('bm:variant-option-change', function (event) {
      selection[event.detail.optionIndex] = event.detail.value;
      var variant = findVariant(selection);
      updatePrice(variant);
      syncVariantForApps(variant);
    });

    /* ---------------- Galería ---------------- */
    // Es fija a propósito: no cambia al elegir opciones, solo con los controles.

    var index = 0;
    var counter = root.querySelector('[data-bm-gallery-counter]');
    var prevBtn = root.querySelector('[data-bm-gallery-prev]');
    var nextBtn = root.querySelector('[data-bm-gallery-next]');

    function show(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) { slide.classList.toggle('is-active', n === index); });
      thumbs.forEach(function (thumb, n) { thumb.classList.toggle('is-active', n === index); });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      var active = thumbs[index];
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    thumbs.forEach(function (thumb, n) {
      thumb.addEventListener('click', function () { show(n); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });

    if (slides.length < 2) {
      [prevBtn, nextBtn, counter].forEach(function (el) { if (el) el.hidden = true; });
    } else {
      show(0);
    }

    // Deslizar con el dedo en móvil
    var stage = root.querySelector('.bm-gallery__stage');
    if (stage && slides.length > 1) {
      var startX = null;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) show(dx < 0 ? index + 1 : index - 1);
        startX = null;
      }, { passive: true });
    }
  }

  function boot() {
    document.querySelectorAll('[data-bm-top]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
